import type { LinkProps } from "react-router"
import { Link } from "react-router"
import type { VehicleDetailsStage } from "./VehicleDetailsStage"

export interface VehicleDetailsStageLinkState {
	editStage?: VehicleDetailsStage
	scrollInstantly?: boolean
}

interface VehicleDetailsStageLinkProps extends LinkProps {
	state?: VehicleDetailsStageLinkState
}

export const VehicleDetailsStageLink = (props: VehicleDetailsStageLinkProps) => <Link {...props} />
